export enum SINGLE_PROJECT_ROUTES_NAMES {
	CHAT = 'chat',
	SingleProject = 'singleProject',
	ProjectSettings = 'projectSettings',
	PlaintCertificateChecklist = 'plaintCertificateChecklist',
	ConfirmityCheckChecklist = 'confirmityCheckChecklist',
	InternalChecklist = 'internalChecklist',
	ActivityLogs = 'activityLogs',
	GeneralInformation = 'generalInformation',
	DocumentChecking = 'documentChecking',
	Products = 'Products',
	PdfViewerInvoice = 'PdfViewerInvoice',
	PdfViewerOffer = 'PdfViewerOffer',
	PdfViewerCertificate = 'PdfViewerCertificate',
	PdfViewerReport = 'PdfViewerReport',
	PdfViewerOtherDocument = 'PdfViewerOtherDocument',
	Calculations = 'Calculations',
	BusinessDocumentation = 'BusinessDocumentation',
	TechnicalDocumentation = 'TechnicalDocumentation'
}

export enum PROJECT_SETTINGS_ROUTES {
	General = 'General',
	EmailReminders = 'EmailReminders',
	AddEmailReminder = 'AddEmailReminder',
	EditEmailReminder = 'EditEmailReminder'
}

export interface IPdfViewerCertificateParams {
	projectId: string | number
	certificateId: string | number
	name: string
	file: string
}
